import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter9 extends Component {
  static displayName = Chapter9.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—9: सिद्धियों का प्रकाश और शिष्यों पर गुरु-शक्ति का प्रभाव 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                स्वामी ब्रह्मानंद सरस्वती जी महाराज का जीवन जितना तप से भरा हुआ था, उतना ही दिव्य सिद्धियों से भी प्रकाशित था। उन्होंने कभी अपनी शक्तियों का प्रदर्शन नहीं किया, परंतु उनके आसपास रहने वाले साधकों, ग्रामीणों और भक्तों ने अनगिनत बार अनुभव किया कि उनकी उपस्थिति मात्र से ही परिस्थितियाँ बदल जाती थीं, संकट मिट जाते थे और मन शांत हो जाता था। उनके जीवन की सिद्धियाँ किसी चमत्कार के लिए नहीं थीं बल्कि लोक-कल्याण के लिए शक्ति का सदुपयोग थीं।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            {/* <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>श्मशान में की गई उनकी कठोर तपस्या।</h3> */}
            
            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>1. वाणी की सिद्धि — वचन ही सत्य हो जाता था</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी जी के मुख से जो भी बोल निकलता— वह मानो सत्य का आदेश बन जाता। कई ग्रामवासी बताते थे कि वे किसी रोगी के पास जाकर बस इतना भर कहते— “चिंता मत करो, तुम ठीक हो जाओगे।” और कुछ ही दिनों में रोग बिना दवा के शांत हो जाता था। उनका आशीर्वाद दवा नहीं था, परंतु शक्ति का संचार था। वे कहा करते थे— “साधक की वाणी तभी प्रभावी होती है, जब वह मन, वचन और कर्म से शुद्ध हो।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>2. ध्यान की शक्ति — मात्र दृष्टि से मन शांत</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              जो भी उनके सामने बैठता था, कहता— “गुरुदेव की आँखों में देखते ही मन की सारी बेचैनी जैसे पिघल गई।” उनकी दृष्टि इतनी शांत, गहरी और निर्विकल्प थी कि सामने वाला व्यक्ति अपने सभी तनाव भूल जाता। यह कोई जादू नहीं था, बल्कि उनकी समाधि की अग्नि जो उनके भीतर निरंतर जलती रहती थी।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>3. प्रकृति पर नियंत्रण जैसा प्रभाव</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उनके तप-बल का प्रभाव ऐसा था कि कई बार ऐसा लगता कि वातावरण स्वयं उनकी आज्ञा मान रहा हो। कई शिष्यों ने अनुभव किया— जब वे तपस्या में होते, तो अचानक हवा शांत हो जाती, चिड़ियाँ स्थिर हो जातीं, और वातावरण में अलौकिक निस्तब्धता भर जाती। ऐसा लगता था मानो प्रकृति स्वयं गुरु-शक्ति के सामने प्रणाम कर रही हो।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>4. भविष्य-दृष्टि और संकटों से रक्षा</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              कई बार शिष्यों ने उन्हें कहते सुना— “इस मार्ग से मत जाओ, अभी ठीक समय नहीं है।” और सचमुच कुछ देर बाद वही मार्ग किसी दुर्घटना या बाधा का स्थान बन जाता। उनकी यह अंतर्दृष्टि भगवती की कृपा से मिली हुई प्रत्यभिज्ञा-सिद्धि थी। वे कभी भविष्य-वाणी नहीं करते थे; परंतु जब करना होता, तो वह अचूक साबित होती।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>5. उनके स्पर्श में ऊर्जा की तरंग</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              शिष्यों को जब वे सिर पर हाथ रखकर आशीर्वाद देते, तो शरीर में मानो कोई विद्युत-धारा प्रवाहित हो जाती। कई शिष्यों ने बताया— “गुरुदेव का स्पर्श मानो हमारे अंदर छिपी सोई हुई शक्ति को जगा देता था।” उनका स्पर्श साधक को धैर्य, निर्भयता और आत्मविश्वास से भर देता था।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>6. गुरुकृपा — शिष्यों के जीवन का परिवर्तन</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              जो उनके पास आता था, वह वही नहीं रहता था।<br/>
                ✔ किसी का क्रोध शांत हो जाता<br/>
                ✔ किसी के भीतर साधना की प्रबल आग जग जाती<br/>
                ✔ कोई जीवन की दिशा पा लेता<br/>
                ✔ कोई दुख से मुक्त होकर आनंद में लौट आता<br/>
                <br/>
                वे कहा करते थे— “सच्चा गुरु शिष्य को अपने जैसा नहीं बनाता, बल्कि उसे उसके सच्चे रूप तक पहुँचा देता है।” उनके शिष्यों के जीवन में यह परिवर्तन उनकी सिद्धियों का नहीं, बल्कि गुरु-हृदय की करुणा और उनकी साधना की गहराई का परिणाम था।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>7. चमत्कार नहीं—साधना का तेज</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी जी कभी भी अपने चमत्कारों का प्रदर्शन नहीं करते थे। वे कहते— “जहाँ प्रदर्शन होता है, वहाँ शक्ति घटती है।” उनकी सिद्धियाँ उनकी साधना की सहज उपज थीं— न कोई दिखावा, न कोई आडंबर। उनके लिए सबसे बड़ा चमत्कार था— शिष्य का आंतरिक परिवर्तन।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>8. गुरु-शक्ति का तेजस्वी आभामंडल</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी जी का चेहरा सदैव शांत, परंतु तेज से भरा रहता था। उनके निकट आने पर ऐसा लगता था कि सूर्य की किरणें भीतर उतर रही हों। कई साधक उनके पास बैठक न कोई मंत्र जपते, न कोई प्रार्थना करते— सिर्फ मौन में बैठते। पर कुछ ही क्षणों में वे अनुभव करते कि उनके जीवन की सारी उलझनें धीरे-धीरे खुलने लगी हैं। यह थी गुरु-शक्ति का प्रभाव, जो बिना बोले भी हृदय को बदल देती थी।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी ब्रह्मानंद सरस्वती जी महाराज की सिद्धियाँ उनकी साधना की कमाई थीं, पर उनका वास्तविक महत्त्व इस बात में था कि उन्होंने उन शक्तियों का प्रयोग कभी अपने लिए नहीं किया— सभी का उपयोग साधकों, भक्तों और समाज के कल्याण के लिए किया। उनके प्रकाश से न केवल उनका जीवन तेजस्वी था, बल्कि उनके शिष्यों और उनके सम्पूर्ण मार्गदर्शन की परंपरा आज भी उसी दिव्य तेज से प्रकाशित है।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter8" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter10" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}